import React, { useEffect, useState } from "react";
import stallBannerImage from '../../assets/stall-banner.png';
import ButtonComponent from "../../components/ButtonComponent/ButtonComponent";
import DropdownComponent from "../../components/DropdownComponent/DropdownComponent";
import InputComponent from "../../components/InputComponent/InputComponent";
import NotificationComponent from "../../components/NotificationComponent/NotificationComponent";
import RadioboxComponent from "../../components/RadioboxComponent/RadioboxComponent";
import { addStallBookingMaster, getEventList } from "../../services/apiController";
import LoaderComponent from "../../components/LoaderComponent/LoaderComponent";

const ApplyForStall = () => {
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        selectedEventId: '', name: '', brandname: '', email: '', whatsapp: '',
        website: '', category: '', fssailicense: '',
        executedbefore: false, requirementscomments: ''
    });
    const [errors, setErrors] = useState({}); // To store validation errors
    const [eventsData, setEventsData] = useState([]);

    // State to manage snackbar visibility and messages
    const [snackbarStates, setSnackbarStates] = useState({ isSnackbarOpen: false, snackbarMessage: '' });
    const handleCloseSnackbar = () => {
        setSnackbarStates({ isSnackbarOpen: false, snackbarMessage: '', snackbarSeverity: '' });
    };

    useEffect(() => {
        wsGetEventData();
    }, []);

    const wsGetEventData = () => {
        setLoading(true);
        getEventList().then((response) => {

            const formattedData = (response.tickets || []).map(item => ({
                id: item.TicketMasterId,
                value: item.EventName
            }));

            setEventsData(formattedData);

            selectDefaultEvent(response);

            setLoading(false);
        }).catch((error) => {
            setLoading(false);
        });
    };

    const selectDefaultEvent = (ticketsData) => {
        ticketsData.tickets.length === 1 && setFormData((prev) => ({ ...prev, selectedEventId: ticketsData.tickets[0]?.TicketMasterId }));
    }

    // Your existing handlers (handleChange, increment, decrement, etc.)
    const handleChange = (e, type, maxLength) => {
        const { name, value } = e.target;
        if (type === 'number') {
            // Allow only digits (0-9), and optionally + at the start
            if (/^\+?\d*$/.test(value)) {
                // Optional: Limit length (e.g., 15 digits max)
                if (value.length <= maxLength) { // + sign + 15 digits
                    setFormData((prev) => ({ ...prev, whatsapp: value }));
                    setErrors((prev) => ({ ...prev, whatsapp: '' }));
                }
            }
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));

            // Clear error when user starts typing
            if (errors[name]) {
                setErrors((prev) => ({ ...prev, [name]: '' }));
            }
        }
    };

    // Email validation function
    const validateEmail = (email) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!email) {
            return 'Email is required';
        }
        if (!emailRegex.test(email)) {
            return 'Please enter a valid email address';
        }
        return '';
    };

    // Form submission with validation
    const handleSubmit = (e) => {
        e?.preventDefault(); // Prevent default if used in <form>

        const newErrors = {};
        if (formData.selectedEventId == "") newErrors.selectedEventId = 'Event is required';
        if (!formData.name.trim()) newErrors.name = 'Name is required';
        if (!formData.brandname.trim()) newErrors.brandname = 'Brand Name is required';
        if (!formData.email.trim()) newErrors.email = 'Email is required';
        if (!formData.whatsapp.trim()) newErrors.whatsapp = 'WhatsApp Contect is required';
        if (!formData.category.trim()) newErrors.category = 'Category is required';
        // if (formData.category === "foodstall" && !formData.fssailicense.trim()) newErrors.fssailicense = 'FSSAI License is required';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        // Validate email
        const emailError = validateEmail(formData.email);
        if (emailError) {
            setErrors({ email: emailError });
            return; // Stop submission
        }
        // Clear any previous errors
        setErrors({});
        // Success: Proceed with submission 
        wsAddStallBooking(formData)
    };

    const wsAddStallBooking = (formData) => {
        setLoading(true);
        const apiParameter = {
            "EventMasterId": formData.selectedEventId,
            "TenantName": formData.name,
            "TenantBrandName": formData.brandname,
            "TenantEmail": formData.email,
            "TenantContactNo": formData.whatsapp,
            "SocialMediaLink": formData.website,
            "CategoryId": formData.category,
            "IsExecutedBefore": formData.executedbefore,
            "SpecialRequirement": formData.requirementscomments,
            "EntryUserMasterId": 1
        };

        addStallBookingMaster(apiParameter)
            .then((response) => {
                if (response.status == 1) {
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.message, snackbarSeverity: 'success' });
                    setFormData({ name: '', brandname: '', email: '', whatsapp: '', website: '', category: '', fssailicense: '', executedbefore: 0, requirementscomments: '' })
                } else {
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.message, snackbarSeverity: 'error' });
                }
                setLoading(false);
            }).catch((error) => {
                setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: "Something went wrong, Please try again", snackbarSeverity: 'error' });
                setLoading(false);
            });
    }

    return (
        loading ? <LoaderComponent />
            : <React.Fragment>
                <NotificationComponent isOpen={snackbarStates.isSnackbarOpen} message={snackbarStates.snackbarMessage} onClose={handleCloseSnackbar} severity={snackbarStates.snackbarSeverity} />

                <img src={stallBannerImage} style={{ width: '100%' }} />

                <div className="booking-container">
                    {/* Card for Ticket Form */}
                    <h2 className="heading">Book A Stall</h2>

                    <div className="form-container">
                        {/* Form Inputs (Text Fields with Underline and Two Columns) */}

                        <DropdownComponent name="selectedEventId" placeholder="Select Event*" value={formData.selectedEventId} onChange={handleChange} error={errors.selectedEventId} options={eventsData} />

                        <div className="form-grid" style={{ marginTop: '30px' }}>
                            <InputComponent name="name" placeholder="Name*" value={formData.name} onChange={handleChange} error={errors.name} />
                            <InputComponent name="brandname" placeholder="Brand Name*" value={formData.brandname} onChange={handleChange} error={errors.brandname} />

                            <InputComponent name="email" type="email" placeholder="Email ID*" value={formData.email} onChange={handleChange} error={errors.email} />
                            <InputComponent name="whatsapp" placeholder="WhatsApp Contect No*" value={formData.whatsapp} onChange={(e) => handleChange(e, 'number', 10)} error={errors.whatsapp} />

                            <InputComponent name="website" placeholder="Your Website Or Social Media Link" value={formData.website} onChange={handleChange} />
                            <DropdownComponent name="category" placeholder="Category*" value={formData.category} onChange={(e) => { handleChange(e); setFormData((prev) => ({ ...prev, fssailicense: "" })); }} error={errors.category}
                                options={[{ id: '1', value: 'Food Stall' }, { id: '2', value: 'Merchant' }, { id: '3', value: 'Display Space' }, { id: '4', value: 'Kiosks' }]}
                            />
                        </div>

                        {/* {formData.category === "foodstall" && <InputComponent name="fssailicense" placeholder="Fssai License No*" value={formData.fssailicense} onChange={handleChange} error={errors.fssailicense} />} */}

                        {/* <div className="sub-heading">Indicate The Kind Of Food You Want To Sale At Akadeet.</div> */}
                        <div style={{ marginTop: '20px' }}>
                            <div className="form-radio-book-stall">
                                <div className="form-radio-book-stall-lable">Have you executed before ?</div>

                                <RadioboxComponent
                                    uniqueId={`radio-yes-id`}
                                    name="executedbefore"
                                    value={formData.executedbefore}
                                    checked={formData.executedbefore}
                                    onChange={() => setFormData((prev) => ({ ...prev, executedbefore: true }))}
                                    label={"Yes"}
                                    style={{ width: '50%' }}
                                />
                                <RadioboxComponent
                                    uniqueId={`radio-no-id`}
                                    name="executedbefore"
                                    value={!formData.executedbefore}
                                    checked={!formData.executedbefore}
                                    onChange={() => setFormData((prev) => ({ ...prev, executedbefore: false }))}
                                    label={"No"}
                                    style={{ width: '50%' }}
                                />
                            </div>
                            {/* <InputComponent multiline name="executedbefore" placeholder="Have you executed before" value={formData.executedbefore} onChange={handleChange} error={errors.executedbefore} /> */}
                            <InputComponent multiline name="requirementscomments" placeholder="Special Requirements/Comments" value={formData.requirementscomments} onChange={handleChange} error={errors.requirementscomments} />
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div style={{ textAlign: 'end', marginBottom: '2%' }}>
                        <ButtonComponent disabled={loading} onClick={handleSubmit}>Send Details</ButtonComponent>
                    </div>
                </div>

            </React.Fragment>
    );
};

export default ApplyForStall;
